import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { CONTEXT_TITLE } from "../../helpers/ModuleHelpers";
import { AEButton } from "../../../../../_emywork/components/buttons";
import {
  AEAutoComplete,
  AEInput,
} from "../../../../../_metronic/_partials/controls";
import { AESVG } from "../../../../../_emywork/components/svg";
import { ButtonGroup, Dropdown, Tooltip } from "react-bootstrap";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { localField } from "../../../../../_emywork/helpers/UIHelper";

import { actionTypes as countriesActionTypes } from "../../../Countries/_redux/slice";
import { fetchEntities as getCountries } from "../../../Countries/_redux/actions";
import { actionTypes as categoriesActionTypes } from "../../../Categories/_redux/slice";
import { fetchEntities as getCategories } from "../../../Categories/_redux/actions";
import { actionTypes as subCategoriesActionTypes } from "../../../Subcategories/_redux/slice";
import {
  fetchEntities as getSubCategories,
  resetEntities as resetSubcategories,
} from "../../../Subcategories/_redux/actions";
import { AEMetadata, UAEMetadata, defaultMeta } from "../../../../../_emywork/AEPagination";
import { actionTypes as projectTypesActionTypes } from "../../../ProjectTypes/_redux/slice";
import { fetchEntities as getProjectTypes } from "../../../ProjectTypes/_redux/actions";
import { actionTypes as legalFormsActionTypes } from "../../../LegalForms/_redux/slice";
import { fetchEntities as getLegalForms } from "../../../LegalForms/_redux/actions";
import { actionTypes as locationsActionTypes } from "../../../Locations/_redux/slice";
import {
  fetchEntities as getLocations,
  resetEntities as resetLocations,
} from "../../../Locations/_redux/actions";
import { actionTypes as paymentTermsActionTypes } from "../../../PaymentTerms/_redux/slice";
import { fetchEntities as getPaymentTerms } from "../../../PaymentTerms/_redux/actions";
import { AEOverlayTrigger } from "../../../../../_emywork/AEOverlayTrigger";
import { AERole } from "../../../../../_emywork/components/AERole";
import { roles } from "../../../../../index";
import { EmyServiceStatus } from "../../componants/Status";
import { getStatusesKeys } from "../../helpers/StatusHelpers";
import { initialFilter, sorts } from "../../helpers/FilterHelpers";
import SkillsFilter from "../../../../../_metronic/layout/components/filters/SkillsFilter";

export const Filter = ({ setFilters, filters, setSort, sort, setSortAsc }) => {
  const dispatch = useDispatch();
  const [advancedFilter, setAdvancedFilter] = useState(false);
  const { formatMessage } = useIntl();
  const {
    authUser,
    countries,
    categories,
    subcategories,
    legal_forms,
    locations,
    payment_terms,
  } = useSelector((state) => {
    const { entities: countries } = state.countries[
      countriesActionTypes.EmyServiceFilter
    ];
    const { entities: categories } = state.categories[
      categoriesActionTypes.EmyServiceFilter
    ];
    const { entities: subcategories } = state.subcategories[
      subCategoriesActionTypes.EmyServiceFilter
    ];
    const { entities: legal_forms } = state.legal_forms[
      legalFormsActionTypes.EmyServiceFilter
    ];
    const { entities: locations } = state.locations[
      locationsActionTypes.EmyServiceFilter
    ];
    const { entities: payment_terms } = state.payment_terms[
      paymentTermsActionTypes.EmyServiceFilter
    ];
    return {
      authUser: state.auth.user,
      countries,
      categories,
      subcategories,
      legal_forms,
      locations,
      payment_terms,
    };
  }, shallowEqual);

  const formik = useFormik({
    initialValues: initialFilter,
    onSubmit: (values) => {
      const {
        search,
        category_id,
        subcategories,
        payment_term_id,
        location_id,
        skills,
        country_id,
        legal_form_id,
        min_price = 0,
        max_price = 0 /*, sort_by*/,
        status,
      } = values;
      let filters = { search };

      // if(category_id) filters.category_id = category_id;
      filters.min_price = min_price || 0;
      if (max_price > 0) {
        filters.max_price = max_price;
      }
      if (location_id) filters.location_id = location_id;
      if (skills.length > 0) filters.skills = skills;
      if (subcategories.length > 0) filters.subcategories = subcategories;
      if (country_id) filters["location.country.id"] = country_id;
      if (legal_form_id) filters["created_by.legal_form.id"] = legal_form_id;
      if (status) filters.status = status;

      setFilters(filters);
    },
  });

  const {
    handleSubmit,
    resetForm,
    getFieldProps,
    values,
    setFieldValue,
  } = formik;

  useEffect(() => {
    dispatch(
      getCategories(
        new AEMetadata({}, {}, {}, [
          "id",
          localField(),
          "subcategories",
          "subcategories.*.skills",
        ]),
        categoriesActionTypes.EmyServiceFilter
      )
    );
    dispatch(
      getProjectTypes(defaultMeta, projectTypesActionTypes.EmyServiceFilter)
    );
    dispatch(getCountries(defaultMeta, countriesActionTypes.EmyServiceFilter));
    dispatch(
      getLegalForms(defaultMeta, legalFormsActionTypes.EmyServiceFilter)
    );
    dispatch(
      getPaymentTerms(
        new AEMetadata({}, {}, {}, ["id", localField(), `_key`]),
        paymentTermsActionTypes.EmyServiceFilter
      )
    );
  }, [dispatch]);

  // ==================

  // useEffect(() => {
  //   if (values.category_id) {
  //     dispatch(
  //       getSubCategories(
  //         new AEMetadata({}, {}, { category_id: values.category_id }, [
  //           "id",
  //           "skills",
  //           localField(),
  //         ]),
  //         subCategoriesActionTypes.EmyServiceFilter
  //       )
  //     );
  //   } else {
  //     dispatch(resetSubcategories(subCategoriesActionTypes.EmyServiceFilter));
  //     setFieldValue("subcategories", []);
  //     setFieldValue("skills", []);
  //   }
  // }, [values.category_id]);

  useEffect(() => {
    if (values.category_id) {
      dispatch(
        getSubCategories(
          new UAEMetadata({}, {}, { category_id: values.category_id }, [
            "id",
            "skills",
            localField(),
          ]),
          subCategoriesActionTypes.EmyServiceFilter
        )
      );
    } else {
      dispatch(resetSubcategories(subCategoriesActionTypes.EmyServiceFilter));
      setFieldValue("subcategories", []);
      setFieldValue("skills", []);
    }
  }, [values.category_id]);

  // ==================

  useEffect(() => {
    if (values.country_id) {
      dispatch(
        getLocations(
          new AEMetadata({}, {}, { country_id: values.country_id }, [
            "id",
            localField(),
          ]),
          subCategoriesActionTypes.EmyServiceFilter
        )
      );
    } else {
      dispatch(resetLocations(locationsActionTypes.EmyServiceFilter));
      setFieldValue("location_id", undefined);
    }
  }, [values.country_id]);

  useEffect(() => {
    if (values.subcategories.length === 0) {
      setFieldValue("skills", []);
    }
  }, [values.subcategories]);

  const getFilterProps = (name, type = AEInput) => {
    return {
      name: name,
      variant: "standard",
      withFeedbackLabel: false,
      validation: false,
      field: getFieldProps(name),
      form: formik,
    };
  };

  //improve : use Api instead
  // const skills = () =>{
  //   let skills = [];

  //   subcategories.filter(sc=>sc.skills).forEach(sc=>{
  //     sc.skills.forEach(s=>{
  //       if(skills.findIndex(_s=>_s.id === s) !== 1){
  //         skills.push(s)
  //       }
  //     })
  //   })

  //   return skills;
  // }

  return (
    <div className="py-5 gutter-b bg-white rounded bg-dark border bgi-no-repeat bg-primary">
      <div className="container d-flex flex-column">
        <div className="d-flex -align-items-sm-end -flex-column -flex-sm-row mb-5">
          <h2 className="d-flex align-items-center mr-5 mb-0">
            {formatMessage(
              { id: "FILTER.TITLE" },
              { name: formatMessage({ id: CONTEXT_TITLE.singular }) }
            )}
          </h2>
          <div className="ml-auto">
            {[
              {
                title: "FILTER.MY_SERVICES",
                svg: "/Shopping/Box2.svg",
                accept: [roles.provider],
                onClickCallBack: () => {
                  setFilters({
                    ...filters,
                    user_id: filters.user_id ? undefined : authUser.id,
                  });
                },
                active: filters.user_id,
              },
              {
                title: "SAVED",
                svg: "/General/Heart.svg",
                accept: [roles.client, roles.provider, roles.super_admin],
                onClickCallBack: () => {
                  setFilters({
                    ...filters,
                    saved_by: filters.saved_by ? undefined : [authUser.id],
                  });
                },
                active: filters.saved_by,
              },
            ].map(
              (
                {
                  title,
                  onClickCallBack = () => { },
                  svg,
                  variant = "primary",
                  accept = [roles.visitor],
                  active = false,
                },
                index
              ) => {
                return (
                  <AERole accept={accept} key={index}>
                    <AEOverlayTrigger
                      placement={"top"}
                      overlay={
                        <Tooltip id={`tooltip_toolbar_action_${index}`}>
                          {formatMessage({ id: title })}
                        </Tooltip>
                      }
                    >
                      <div
                        className={`btn btn-icon -bg-light mr-3 btn-hover-icon-${variant} text-white`}
                        onClick={onClickCallBack}
                      >
                        <AESVG
                          path={svg}
                          variant={active ? variant : ""}
                          size={"2x"}
                        />
                      </div>
                    </AEOverlayTrigger>
                  </AERole>
                );
              }
            )}

            <Dropdown as={ButtonGroup}>
              <AEButton
                variant={"light"}
                fontWeight={"bolder"}
                onClick={() => {
                  setSortAsc(!sort.asc);
                }}
              >
                <AESVG
                  path={`/Navigation/${sort.asc ? "Up" : "Down"}-2.svg`}
                  variant={"primary"}
                />
                {formatMessage({
                  id:
                    sorts.findIndex((o) => o.prop === sort.field) !== -1
                      ? sorts.find((o) => o.prop === sort.field).label
                      : "SORT",
                })}
              </AEButton>
              <Dropdown.Toggle split variant="light-primary" />
              <Dropdown.Menu className={"py-5"}>
                {sorts.map((o) => (
                  <Dropdown.Item
                    key={o.prop}
                    onClick={() => {
                      setSort(o.prop, o.asc);
                    }}
                  >
                    {formatMessage({ id: o.label }, { asc: o.asc })}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown as={ButtonGroup} className={"pl-2"}>
              <AEButton
                variant={"light"}
                fontWeight={"bolder"}
                onClick={handleSubmit}
              >
                <AESVG path={"/Navigation/Check.svg"} variant={"primary"} />
                {formatMessage({ id: "APPLY" })}
              </AEButton>
              <Dropdown.Toggle split variant="light-primary" />
              <Dropdown.Menu className={"py-5"}>
                <Dropdown.Item
                  onClick={() => {
                    resetForm();
                    handleSubmit();
                  }}
                >
                  {/*<AESVG path={"/General/Update.svg"} variant={"primary"} className={"pr-3"}/>*/}
                  {formatMessage({ id: "RESET" })}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(event) => {
                    setAdvancedFilter(!advancedFilter);
                  }}
                >
                  {formatMessage({
                    id: `FILTER.ADVANCED.${advancedFilter ? "LESS" : "MORE"}`,
                  })}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <form className="bg-white rounded pt-0 pb-4 px-2 row">
          <div className={`col-lg-3`}>
            <AEInput {...getFilterProps("search")} label={"SEARCH"} />
          </div>
          <div className={`col-lg-3`}>
            <AEAutoComplete
              {...getFilterProps("category_id")}
              label={"CATEGORY"}
              options={categories}
              useId
              getOptionLabel={(o) => o[localField()]}
            />
          </div>
          <div className={`col-lg-3`}>
            <AEAutoComplete
              {...getFilterProps("subcategories")}
              label={"SUBCATEGORIES"}
              options={subcategories}
              useId
              multiple
              getOptionLabel={(o) => o[localField()]}
            />
          </div>
          <div className={`col-lg-3`}>
            <SkillsFilter
              dispatch={dispatch}
              dispatchedAction={"EmyServiceFilter"}
              values={formik.values.skills}
              setFieldValue={setFieldValue}
            />
          </div>
          {advancedFilter && (
            <>
              <div className={`col-lg-3`}>
                <AEAutoComplete
                  {...getFilterProps("legal_form_id")}
                  label={"LEGAL_FORM"}
                  options={legal_forms}
                  useId
                  getOptionLabel={(o) => o[localField()]}
                />
              </div>
              <div className={`col-lg-3`}>
                <AEAutoComplete
                  {...getFilterProps("country_id")}
                  label={"COUNTRIES"}
                  options={countries}
                  useId
                  getOptionLabel={(o) => o[localField()]}
                />
              </div>
              <div className={`col-lg-3`}>
                <AEAutoComplete
                  {...getFilterProps("location_id")}
                  label={"LOCATIONS"}
                  options={locations}
                  useId
                  getOptionLabel={(o) => o[localField()]}
                />
              </div>
              <div className={`col-lg-3`}>
                <AEInput
                  {...getFilterProps("min_price")}
                  label={"MIN_PRICE"}
                  type={"number"}
                />
              </div>
              <div className={`col-lg-3`}>
                <AEInput
                  {...getFilterProps("max_price")}
                  label={"MAX_PRICE"}
                  type={"number"}
                />
              </div>
              <AERole accept={[roles.super_admin]}>
                <div className={`col-lg-3`}>
                  <AEAutoComplete
                    {...getFilterProps("status")}
                    label={"STATUS"}
                    options={getStatusesKeys()}
                    getOptionLabel={(o) => formatMessage({ id: o })}
                    renderOption={(o) => <EmyServiceStatus status={o} />}
                  />
                </div>
              </AERole>
            </>
          )}
        </form>
      </div>
    </div>
  );
};
